import moment from 'moment';
import Masker from 'vanilla-masker'

// Mascara valor inteiro para real
export function price(value = 0){  return value < 0 ? '-' + Masker.toMoney(value) : Masker.toMoney(value);}

// Mascara número de telefone
export function mobile(value = ''){ return Masker.toPattern(value, '(99) 9 9999 9999') }

// Mascara data no formado PT-BR
export function date(value = ''){ return Masker.toPattern(value, '99/99/9999') }

// Mascara número de CPF
export function cpf(value = ''){ return Masker.toPattern(value, '999.999.999-99') }

// Mascara número de CNPJ
export function cnpj(value = ''){ return Masker.toPattern(value, '99.999.999/9999-99') }

// Mascara de código postal
export function zip(value = ''){ return Masker.toPattern(value, '99999-999') }

// Converte data
export function dateTime(value){ return moment(value).format('DD/MM/YYYY HH:mm') }

// Dígitos
export function digit(value = ''){ return value?.replace(/\D/g, '') }